import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  imageProcessing,
  ImageSnippet,
} from "src/app/utils/image-processing-utils";
import * as moment from 'moment-timezone';
import { getAddressDetails, getBrokersList } from "src/app/utils/utils.common";
import { sweetAlert } from "src/app/utils/swal";
import { MemberService } from "../member-service/member.service";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { TRIPREASONLIST } from "src/app/utils/utils.common";
import { ProTipsServiceService } from "../../helping-material/nemt-pro-tips/service/pro-tips-service.service";
import { forkJoin } from "rxjs";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DriversService } from "../../drivers/drivers-service/drivers-service";
@Component({
  selector: "app-create-member",
  templateUrl: "./create-member.component.html",
  styleUrls: ["./create-member.component.css"],
})
export class CreateMemberComponent implements OnInit, OnDestroy, OnChanges {
  @Input() clientId?: string;
  @Input() source?: string;
  @Output() onSave = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  memberForm: FormGroup;
  commentForm: FormGroup;
  user;
  tripReasonList = TRIPREASONLIST;
  submitted = false;
  cmtSubmitted = false;
  submittedFile = false;
  selectedFile: ImageSnippet = null;
  memberId;
  corporateUsers = [];
  status = "active";
  spaceTypes = [];
  levelOfServices = [];
  spaceTypeMainList = [];
  drivers = [];


  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private sharedDataService : SharedDataService,
    private router: Router,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private proTips: ProTipsServiceService,
    private driverService: DriversService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clientId && changes.clientId.currentValue) {
      this.memberId = changes.clientId.currentValue;
      this.getMember(this.memberId);
    }
  }

  ngOnInit() {

    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.memberId = this.activatedRoute.snapshot.url[2].path;
    }

    this.memberForm = this.fb.group({
      firstName: ["", Validators.required],
      middleName: [""],
      lastName: ["", Validators.required],
      email: [""],
      clientId: ["", Validators.required],
      preDob:["",],
      dob: ["",],
      contactNumber: ["", Validators.required],
      cellPhone: [""],
      wmrNumber:[''],
      los: [""],
      spaceType: [""],
      fundingSource: ["",Validators.required,],
      gender: ["", Validators.required],
      weight: [""],
      height: [""],
      stairsStep: [""],
      covidStatus: [""],
      privateNote: [""],
      note: [""],
      clientType : ["", Validators.required],
      password: [''],
      smsConsent: [false],

      statusDetails: this.fb.group({
        preExpiryDate: [''],
        expiryDate: [""],
        reason: [""],
      }),

      type: ["regular"],
      preVipExpiryDate: [''],
      vipExpiryDate: [""],
      homeAddress: this.fb.group({
        name: [""],
        address: ["", Validators.required],
        aptOrSuite: [""],
        zipCode: [""],
        state: [""],
        city: [""],
        latitude: [""],
        longitude: [""],
        street: [""]
      }),
      profileImageURL : [""],
      accountStatus: ["", Validators.required],
      history: [[]],
      caregiverInfo: this.fb.array([]),
      eligibility: this.fb.group({
        status: ['pending'],
        preStartDate: [''],
        startDate: [''],
        preEndDate: [''],
        endDate: [''],
        tripQuota: [0]
      }),
      isPrefferedFemale: [false],
      preferredDriver: [''],
      declinedDriver: [''],
      notCarpool: [false],
    });

    this.commentForm = this.fb.group({
      text:['', Validators.required],
      createdAt: [''],
      createdBy:[''],
      relation:['']
    })

    this.memberForm.controls.los.valueChanges.subscribe(value => {
      if (value) {
        this.memberForm.get('spaceType').setValidators([Validators.required]);
      } else {
        this.memberForm.get("spaceType").clearValidators();
      }
      this.memberForm.get('spaceType').updateValueAndValidity();
    });

    this.makeCompulsoryCalls();
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;

          this.commentForm.patchValue({
            createdBy:this.user.displayName
          })
          this.memberForm.patchValue({
            eligibility: {
              preStartDate: moment.tz(this.user.timeZone).startOf('day'),
              startDate: moment.tz(this.user.timeZone).startOf('day').toISOString(),
              preEndDate: moment.tz(this.user.timeZone).endOf('day').add(1, 'month'),
              endDate: moment.tz(this.user.timeZone).endOf('day').add(1, 'month').toISOString()
            }
          })
          this.getDrivers();
        }
      });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getFundingSourceList(),
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3]) => {

        if (res1) {
          this.corporateUsers = res1;
        }
        if (res2) {
          this.levelOfServices = res2;
        }
        if (res3) {
          this.spaceTypeMainList = res3;
        }

        if (this.memberId) {
          this.getMember(this.memberId);
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  onChangeAccountStatus(value) {
      if (value === 'inactive') {
        this.memberForm.controls.statusDetails.get('reason').setValidators([Validators.required]);
      } else {
        this.memberForm.controls.statusDetails.get('reason').clearValidators();
      }
      this.memberForm.controls.statusDetails.get('reason').updateValueAndValidity();
  }

  onChangeReason(value) {
      if (value === 'expired') {
        this.memberForm.controls.statusDetails.get('expiryDate').setValidators([Validators.required]);
      } else {
        this.memberForm.controls.statusDetails.get("expiryDate").clearValidators();
      }
      this.memberForm.controls.statusDetails.get('expiryDate').updateValueAndValidity();
  }

  onChangeType(value) {
    if (value === 'vip'){
      this.memberForm.get('vipExpiryDate').setValidators([Validators.required]);
    }
    else {
      this.memberForm.get("vipExpiryDate").clearValidators();
    }
    this.memberForm.get('vipExpiryDate').updateValueAndValidity();
  }

  onChangeClientType(value){
    if (value === 'passenger') {
      this.memberForm.get('email').setValidators([Validators.required]);
      this.memberForm.get('password').setValidators([Validators.required]);
    } else {
      this.memberForm.get('email').clearValidators();
      this.memberForm.get('password').clearValidators();
    }
    this.memberForm.get('email').updateValueAndValidity();
    this.memberForm.get('password').updateValueAndValidity();
  }

  getMember(memberId) {
    this.memberService
      .getMemberById(memberId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberForm.patchValue({
            ...data,
            password: '',
            preDob: data.dob?  moment(data.dob):'',
            dob:data.dob,
            eligibility: {
              ...data.eligibility,
              preStartDate: data.eligibility && data.eligibility.startDate ? moment(data.eligibility.startDate) : '',
              startDate: data.eligibility ? data.eligibility.startDate : '',
              preEndDate: data.eligibility && data.eligibility.endDate ? moment(data.eligibility.endDate) : '',
              endDate: data.eligibility ? data.eligibility.endDate : '',
            }
          });

          if (data.statusDetails && data.statusDetails.reason === 'expired') {
            this.memberForm.patchValue({
              statusDetails: {
                ...data.statusDetails,
                preExpiryDate: data.statusDetails.expiryDate
              }
            });
          }
          if (data.caregiverInfo && data.caregiverInfo.length) {
            this.addCareGiver(data.caregiverInfo);
          }
          if (data.type && data.type === 'vip'){
            this.memberForm.patchValue({
                ...data,
                preVipExpiryDate: data.vipExpiryDate
            });
          }
          this.onSelectLOS(data.los);
        }
      });
  }

  saveMember() {
    this.submitted = true;

    if (this.memberForm.invalid) {
      return;
    }

    const payload = this.memberForm.value
    if (payload.accountStatus === 'active') {
      delete payload.statusDetails;
    }

    if (payload.clientType === 'patient' || !payload.password) {
      delete payload.password;
    }

    if (payload.accountStatus === 'inactive' &&  payload.statusDetails.reason != 'expired') {
      delete payload.statusDetails.expiryDate;
    }

    if (payload.type &&  payload.type != 'vip') {
      delete payload.vipExpiryDate;
    }

    if (!payload.type) {
      delete payload.type;
    }

    if (!payload.spaceType) {
      delete payload.spaceType ;
    }

    if (!payload.los) {
      delete payload.los;
    }

    if (!payload.email ) {
      delete payload.email;
    }

    if (!payload.fundingSource) {
      delete payload.fundingSource;
    }

    this.callMemberApi(payload);
  }

  callMemberApi(payload, isFromHistory?) {
    this.memberService
    .saveMember(this.memberId, payload)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        if (this.source === 'modal') {
          this.onSave.emit(data);
          this.onCloseModal.emit();
        } else {
          if (isFromHistory) {
            this.memberForm.patchValue({
              history: data.history
            })
            this.commentForm.reset();
            this.cmtSubmitted = false;
          } else {
            this.router.navigateByUrl('credentialing/members');
          }
        }
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }


  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  setAddress(place) {
    // debugger;
    const addressDetails = place ? getAddressDetails(place) : undefined;
    this.memberForm.patchValue({
      homeAddress: {
        address: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        ...addressDetails
      }
    });
  }

  getFundingSourceList() {

    return this.corporateService.getCorporateUsers('active');
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  addComment() {
    this.cmtSubmitted = true;
    if (this.commentForm.invalid) {
      return;
    }

    const newComment = { ...this.commentForm.value, createdAt: moment().tz(this.user.timeZone).toISOString() };
    if (this.commentForm.value.relation) {
      this.callMemberApi({ history: [...this.memberForm.value.history, newComment] }, true);
    } else {
      this.callMemberApi({ history: [...this.memberForm.value.history, newComment] }, true);
    }

  }

  trimId(str) {
    if(str){
      return str.substring(str.length-8, str.length);
    }
  }

  cancelReply(){
    this.commentForm.reset();
  }

  onCommentEdit(comment) {
    this.commentForm.patchValue({
      ...comment,
      relation: comment._id,
      createdBy: this.user.displayName

    })
  }

  onSelectLOS(losId) {
    this.spaceTypes = [];
    if (!losId) {
      this.memberForm.patchValue({
        spaceType: ''
      });
      return;
    };

    this.spaceTypes = this.spaceTypeMainList.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypes.filter(spaceTypeItem => spaceTypeItem._id === this.memberForm.value.spaceType);
    if (!spaceTypes.length) {
      this.memberForm.patchValue({
        spaceType: ''
      });
    }

}

async fileProcessing(ImageInput, form) {
  imageProcessing(ImageInput)
   .subscribe(async (result) => {
    const data:any =  await this.proTips.changeCoverImage(result.file).toPromise();
    form.setValue(data.location);
  })
}

  get form() {
    return this.memberForm.controls;
  }

  get addressForm() {
    return this.memberForm.controls.homeAddress['controls'];
  }

  get statusForm() {
    return this.memberForm.controls.statusDetails['controls'];
  }

  get historyForm() {
    return this.commentForm.controls;
  }

  get eligibilityForm() {
  return this.memberForm.controls.eligibility['controls'];
}


  addCareGiver(preInformation?) {
    const items = this.memberForm.get('caregiverInfo') as FormArray;

    if (preInformation) {
      for (const info of preInformation) {
        items.push(
          this.fb.group({
            name: [info.name, Validators.required],
            relation: [info.relation],
            contactNumber: [info.contactNumber, [Validators.required]],

          })
        );

      }
      return;
    }

    items.push(
      this.fb.group({
        name: ['', Validators.required],
        relation: [''],
        contactNumber: ['', [Validators.required]],

      })
    );
  }


  removeCareGiver(index: any) {
    const items = this.memberForm.get('caregiverInfo') as FormArray;
    items.removeAt(index);
  }


  get careGiverForm() {
    return this.memberForm.get('caregiverInfo') as FormArray;
  }

  togglePrefferedFemale() {
    this.memberForm.patchValue({
      isPrefferedFemale: !this.memberForm.value.isPrefferedFemale
    });
  }

  toggleCarpool() {
    this.memberForm.patchValue({
      notCarpool: !this.memberForm.value.notCarpool
    });
  }

  getDrivers() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.drivers = data;
          }
        }
      );
  }

  ngOnDestroy(): void {
  }
}
